import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-partners',
  imports: [CommonModule, TooltipModule],
  templateUrl: './partners.component.html',
  styleUrl: './partners.component.scss'
})
export class PartnersComponent {

  partners = [
    {
      photo: 'images/tupuca.png',
      tooltip: 'Tupuca'
    },
    {
      photo: 'images/fi.png',
      tooltip: 'Founder Institute'
    },
    {
      photo: 'images/logoOluali.png',
      tooltip: 'Olualinet'
    },
    {
      photo: 'images/cmc.png',
      tooltip: 'Comissão do Mercado de Capitais'
    },
    {
      photo: 'images/emis.png',
      tooltip: 'Emis'
    },
  ];
}